import PropTypes from 'prop-types';
import RecipeImageProps from 'components/RecipeImage/RecipeImageProps';

const collection = PropTypes.shape({
  created_at: PropTypes.string,
  description: PropTypes.string,
  name: PropTypes.string,
  state: PropTypes.string,
  id: PropTypes.number,
  items: PropTypes.shape({
    people: PropTypes.array,
    books: PropTypes.array,
    content: PropTypes.array,
  }),
  items_count: PropTypes.shape({
    people: PropTypes.number,
    books: PropTypes.number,
    contents: PropTypes.number,
  }),
  cover_image: PropTypes.shape({
    id: PropTypes.string,
    book: PropTypes.shape({
      image_name: PropTypes.string,
      image_permission: PropTypes.bool,
      title: PropTypes.string,
    }),
    graphics: RecipeImageProps.graphics,
    instagram_url: PropTypes.string,
  }),
  custom_cover_image: PropTypes.string,
  custom_hero_image: PropTypes.string,
});

export default {
  collection,
  collections: PropTypes.arrayOf(collection),
};
